<template>
  <div class="board-layout">
    <template v-if="isNoPermission">
      <div class="board-layout-box">
        <Empty empty-text="暂无查看权限" />
      </div>
    </template>
    <template v-else>
      <div class="board-content">
        <div class="board-content-top">
          <div class="left">
            <div v-if="$slots.title" class="board-content-title">
              <slot name="title"></slot>
            </div>
            <div class="board-content-subtitle">
              <slot name="desc"></slot>
            </div>
          </div>
          <div v-if="$slots.btn" class="right">
            <slot name="btn"></slot>
          </div>
        </div>
        <div class="board-content-box">
          <slot name="content"></slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import Empty from '@/components/Empty/index.vue'

defineProps({
  isNoPermission: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss">
.board-layout {
  flex: 1;
  overflow: hidden;
  position: relative;
  padding: 8px;
  display: flex;
  flex-direction: column;
  background-size: cover; /* 覆盖整个容器 */
  background-position: center; /* 居中显示 */
  background-repeat: no-repeat; /* 不重复 */
  .board-layout-box {
    flex: 1;
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .board-tab {
    margin-bottom: 8px;
    flex: 0 0 auto;
  }
  .board-content {
    flex: 1;
    position: relative;
    overflow: hidden;
    z-index: 1;
    background: #fff;
    border-radius: 12px;

    /* 自动布局 */
    display: flex;
    flex-direction: column;
    padding: 0px;
    background: linear-gradient(152deg, #e9ecfa 0%, #dfeeff 100%);
    box-sizing: border-box;
    border: 1px solid #ffffff;
    box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    .board-content-top {
      flex: 0 0 auto;
      padding: 16px;
      display: flex;
      .left {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-items: baseline;
      }
      .right {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
      }
      .board-content-title {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #323233;
        margin-bottom: 4px;
      }
      .board-content-subtitle {
        font-family: PingFang SC;
        font-size: 14px;
        line-height: 20px;
        color: #646566;
      }
    }
    .board-content-box {
      flex: 1;
      overflow: hidden;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      background: #ffffff;
    }
  }
}
</style>
